import { ArrowLeft, Mail } from "lucide-react";
import { Link } from "react-router-dom";

export default function Contact() {
  return (
    <div className="min-h-screen bg-[#0A0A0A]" data-testid="contact-page">
      <div className="max-w-3xl mx-auto px-6 md:px-12 py-16 md:py-24">
        <Link to="/" className="inline-flex items-center gap-1.5 text-zinc-400 hover:text-white text-sm font-medium mb-10 transition-colors" data-testid="back-home">
          <ArrowLeft size={16} /> Back to home
        </Link>

        <h1 className="text-3xl sm:text-4xl font-extrabold text-white tracking-tight mb-6" style={{ fontFamily: "'Plus Jakarta Sans', sans-serif" }}>
          Contact
        </h1>

        <p className="text-zinc-300 text-base leading-relaxed mb-8">
          Have a question, want to see a demo, or need support? We'd love to hear from you.
        </p>

        <div className="bg-zinc-900/50 border border-white/5 rounded-2xl p-8 inline-flex items-center gap-4">
          <div className="w-12 h-12 rounded-xl bg-blue-500/10 flex items-center justify-center">
            <Mail size={22} className="text-blue-400" />
          </div>
          <div>
            <p className="text-zinc-400 text-sm mb-1">Email</p>
            <a href="mailto:mo@appointext.ai" className="text-white text-lg font-semibold hover:text-blue-400 transition-colors">
              mo@appointext.ai
            </a>
          </div>
        </div>

        <p className="text-zinc-500 text-sm mt-8 leading-relaxed">
          For support requests, please include your business name and a description of what you need help with.
        </p>
      </div>
    </div>
  );
}
